import {IMGPW} from '@/config';
import {BarCategorySettings} from '@winelivery-org/wl-client-sdk-js';
import {SearchProduct} from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import {SearchProductAttribute} from '@winelivery-org/wl-client-sdk-js/src/models/search';
import {capitalize} from 'lodash';

export interface BarStoreRecord {
  id: string;
  name: string;
  image: string;
  address: string;
  position: {
    latitude: number;
    longitude: number;
  };
  mapsData?: {
    name: string;
    placeId: string;
  };
  openingHours: string;
  providerId?: number;
}

export const barList: BarStoreRecord[] =
  process.env.NODE_ENV !== 'production'
    ? [
        {
          id: '5c000c12c8a4a7002f8a023f',
          name: 'Winelivery Pop Milano',
          address: `Corso di Porta Ticinese 60, Milano`,
          image: `${IMGPW}/bar_pop.jpg`,
          position: {
            latitude: 45.4557698,
            longitude: 9.180595799999999,
          },
          mapsData: {
            name: 'Winelivery+PoP',
            placeId: 'ChIJwXtFvCzDhkcR2eXiEoXFBHY',
          },
          openingHours:
            'Mar: 17:00 - 00:00\nMer - Ven: 18:00 - 00:00\nSab: 17:00 - 00:00',
          providerId: 71,
        },
      ]
    : [
        {
          id: '65310b3cd6d8ef00614688e0',
          name: 'Winelivery Bar & Enoteca Andria',
          address: `Via Regina Margherita 134, Andria`,
          image: `${IMGPW}/bar_andria.jpeg`,
          position: {
            latitude: 41.2283453,
            longitude: 16.3024233,
          },
          mapsData: {
            name: 'Winelivery+Bar+%26+Enoteca+Andria',
            placeId: 'ChIJVQP4yR4bOBMRQ-0bO_29Gak',
          },
          openingHours: 'Lun - Dom: 11:00 - 15:00, 18:00 - 00:00',
          providerId: 96,
        },
        {
          id: '64a690ca9c1eb10065b3251e',
          name: 'Winelivery Bar Navigli Milano',
          address: `Via Casale 3A, Milano`,
          image: `${IMGPW}/bar_milano_navigli.jpg`,
          position: {
            latitude: 45.45207509999999,
            longitude: 9.170457899999999,
          },
          mapsData: {
            name: 'Winelivery+Bar+Navigli',
            placeId: 'ChIJtRMh3DPDhkcRZGqsE4UtCHA',
          },
          openingHours: 'Dom - Gio: 16:00 - 01:00\nVen - Sab: 16:00 - 02:00',
          providerId: 93,
        },
        {
          id: '6440fcce1bc2420066c4f1a2',
          name: 'Winelivery Enoteca Largo Somalia',
          address: `Largo Somalia 45, Roma`,
          image: `${IMGPW}/enoteca_roma_somalia.jpeg`,
          position: {
            latitude: 41.9357802,
            longitude: 12.515515,
          },
          mapsData: {
            name: 'Winelivery+Roma',
            placeId: 'ChIJTXQaOLNhLxMR8cy8t630H0k',
          },
          openingHours:
            'Lun: 17:00 - 00:00\nMar - Dom: 10:30 - 13:30, 17:00 - 00:00',
          providerId: 98,
        },
        {
          id: '642a8e73e420910068bc7ffb',
          name: 'Winelivery Enoteca Monteverde',
          address: `Via di Monte Verde 53D, Roma`,
          image: `${IMGPW}/bar_roma_monteverde.jpg`,
          position: {
            latitude: 41.8703854,
            longitude: 12.4427975,
          },
          mapsData: {
            name: 'Winelivery+Enoteca+Monteverde',
            placeId: 'ChIJWfRkgQGLJRMR_faZznpsJ0Y',
          },
          openingHours:
            'Lun - Ven: 17:00 - 00:00\nSab - Dom: 11:00 - 14:30, 17:30 - 00:00',
          providerId: 99,
        },
        {
          id: '6661d4ceaf7f676556049020',
          name: 'Winelivery Bar & Enoteca Milano Darsena',
          address: `Alzaia Naviglio Pavese 2, Milano`,
          image: `${IMGPW}/bar_darsena.jpg`,
          position: {
            latitude: 45.4520083,
            longitude: 9.177688,
          },
          mapsData: {
            name: 'Winelivery+Bar+%26+Enoteca+Milano+Darsena',
            placeId: 'ChIJu_tO-3nDhkcRBS2Ym_2ETGE',
          },
          openingHours: 'Dom - Gio: 16:00 - 01:00\nVen - Sab: 16:00 - 02:00',
          providerId: 102,
        },
        {
          id: '662b5490884ceb0c4e02f8d6',
          name: 'Winelivery Bar & Enoteca Roma Eur',
          address: `Viale America 17, Roma`,
          image: `${IMGPW}/bar_eur.jpeg`,
          position: {
            latitude: 41.8316049,
            longitude: 12.4594825,
          },
          mapsData: {
            name: 'Winelivery+Bar+%26+Enoteca+Roma+EUR',
            placeId: 'ChIJ5WCiAQCLJRMRZZ3L8OoVO_E',
          },
          openingHours: 'Lun - Dom: 18:00 - 00:00',
          providerId: 103,
        },
        {
          id: '59b9012ec6abe7002451cf35',
          name: 'Winelivery Enoteca Bologna',
          address: `Via Sant\'Isaia 68A, Bologna`,
          image: `${IMGPW}/bar_bologna.jpeg`,
          position: {
            latitude: 44.4940716,
            longitude: 11.328879,
          },
          mapsData: {
            name: 'Winelivery+Bologna',
            placeId: 'ChIJOyJ-djDVf0cR1VX6yfnjP6E',
          },
          openingHours:
            'Lunedì: 11:30 – 00:00\n' +
            'Martedì: 11:30 – 00:00\n' +
            'Mercoledì: 11:00 – 00:00\n' +
            'Giovedì: 11:30 – 00:00\n' +
            'Venerdì: 11:30 – 01:00\n' +
            'Sabato: 11:30 – 01:00\n' +
            'Domenica: 11:30 – 00:00',
          providerId: 108,
        },
        {
          id: '651be7af2befec0064978cca',
          name: 'Winelivery Enoteca Firenze',
          address: `Via Fra\' Bartolomeo 18R, Firenze`,
          image: `${IMGPW}/bar_firenze.jpg`,
          position: {
            latitude: 43.783863,
            longitude: 11.2633787,
          },
          mapsData: {
            name: 'Winelivery+Firenze',
            placeId: 'ChIJ8ZpmNstTKhMRotyX0NHz3nY',
          },
          openingHours: 'Lun - Dom: 17:00 - 23:00',
          providerId: 107,
        },
        {
          id: '6814845eba180821f11b3da5',
          name: 'Winelivery Bar & Enoteca Torino',
          address: `Via Maria Vittoria 23b, Torino`,
          image: `${IMGPW}/bar_torino.jpg`,
          position: {
            latitude: 45.0669947,
            longitude: 7.6822456,
          },
          mapsData: {
            name: 'Winelivery+Bar+%26+Enoteca+Torino',
            placeId: 'ChIJ8a7KPUBtiEcRUj0syo4PpiY',
          },
          openingHours: 'Mar - Gio: 16:00 - 22:00\nVen - Sab: 16:00 - 02:00\nDom: 16:00 - 00:00',
          providerId: 109,
        },
        {
          id: '681484bc5f39e9a3ca4142a7',
          name: 'Winelivery Bar & Enoteca Milano Citylife',
          address: `Via Giovanni da Procida 5, Milano`,
          image: `${IMGPW}/bar_citylife.jpg`,
          position: {
            latitude: 45.4793218,
            longitude: 9.1616681,
          },
          mapsData: {
            name: 'Winelivery+Bar%26Enoteca+Citylife',
            placeId: 'ChIJZ_6brVDBhkcRxNiwPuQpUzg',
          },
          openingHours: 'Mar - Dom: 18:00 - 23:00',
          providerId: 110,
        },
        {
          id: '692d7a170113087af1297d0d',
          name: 'Winelivery Bar & Enoteca Genova',
          address: `Via Giordano Bruno 12R, Genova`,
          image: `${IMGPW}/bar_genova.jpg`,
          position: {
            latitude: 44.3919002,
            longitude: 8.9706155,
          },
          mapsData: {
            name: 'Winelivery+Bar%26Enoteca+Genova',
            placeId: 'ChIJI7XkzYZD0xIRZEKFsSrkXHw',
          },
          openingHours: 'Lun: 17:00 - 00:00\nMer - Dom: 17:00 - 00:00',
          providerId: 111,
        },
      ];

export interface BarCategory {
  _id: string;
  id: string;
  name: string;
  icon_url: string;
  products: SearchProduct[];
}

function splitProducts(products: SearchProduct[]): {
  bar: SearchProduct[];
  take_away: SearchProduct[];
} {
  const bar = products.filter(
    (p) =>
      !(
        p.category.slug === 'snack-and-appetizers' && !p.hTags.includes('food')
      ),
  );

  const take_away = products.filter(
    (p) => !(p.hTags.includes('glass') || p.hTags.includes('food')),
  );

  return {
    bar,
    take_away,
  };
}

function splitProductsByCategory(products: SearchProduct[]) {
  const categories: Map<string, BarCategory> = new Map();

  products.forEach((product) => {
    if (product.hTags.includes('glass') && product.category.slug === 'wine') {
      if (!categories.has('wine-glasses')) {
        categories.set('wine-glasses', {
          products: [],
          _id: 'wine-glasses',
          id: 'wine-glasses',
          icon_url: product.category.iconUrl || '',
          name: 'wine-glasses',
        });
      }
      categories.get('wine-glasses')?.products.push(product);
      return;
    }

    if (product.hTags.includes('glass') && product.category.slug === 'drink') {
      if (!categories.has('spirits-glasses')) {
        categories.set('spirits-glasses', {
          products: [],
          _id: 'spirits-glasses',
          id: 'spirits-glasses',
          icon_url: product.category.iconUrl || '',
          name: capitalize(product.category.name),
        });
      }
      categories.get('spirits-glasses')?.products.push(product);
      return;
    }

    if (!categories.has(product.category.slug)) {
      categories.set(product.category.slug, {
        _id: product.category.id,
        id: product.category.slug,
        icon_url: product.category.iconUrl || '',
        name:
          product.category.slug === 'wine'
            ? 'bottles'
            : capitalize(product.category.name),
        products: [],
      });
    }

    categories.get(product.category.slug)?.products.push(product);
  });

  return [...categories.values()];
}

function filterCategories(
  barCategories: BarCategory[],
  categoriesSettings: BarCategorySettings[],
  service: 'bar' | 'take_away',
) {
  return barCategories.filter((barCategory) => {
    if (barCategory.products.length < 1) {
      return false;
    }
    const found = categoriesSettings.find(
      (category) => category.id === barCategory.id,
    );
    return found && found.services.includes(service);
  });
}

function getBarCategory(
  categories: BarCategory[],
  categoryId: string,
  service: string,
) {
  if (categoryId === 'wine' && service === 'bar') {
    return categories.find((category) => category.name === 'bottles');
  }

  return categories.find((category) => category.id === categoryId);
}

function extractSubcategories(products: SearchProduct[]) {
  const subcategories = new Map<string, SearchProductAttribute>();

  products.forEach((product) => {
    if (!subcategories.has(product.subcategory.slug)) {
      subcategories.set(product.subcategory.slug, product.subcategory);
    }
  });

  return [...subcategories.values()];
}

function sortCategoriesByRank(
  categories: BarCategory[],
  categoriesSettings: BarCategorySettings[],
) {
  return categories.sort((a, b) => {
    const rankingA = categoriesSettings.find((r) => r.id === a.id);
    if (!rankingA) {
      return 1;
    }

    const rankingB = categoriesSettings.find((r) => r.id === b.id);
    if (!rankingB) {
      return -1;
    }

    return rankingA.rank - rankingB.rank;
  });
}

export function getCategoryProductsAndSubcategories(
  categoryId: string,
  products: SearchProduct[],
  service: 'bar' | 'take_away',
): {category: BarCategory; subcategories: SearchProductAttribute[]} {
  // (1)
  const {bar, take_away} = splitProducts(products);

  // (2)
  const categories = splitProductsByCategory(
    service === 'bar' ? bar : take_away,
  );

  // (3)
  const barCategory = getBarCategory(categories, categoryId, service);

  // (4)
  const subcategories = extractSubcategories(barCategory!.products);

  return {category: barCategory!, subcategories};
}

export function getAvailableCategories(
  products: SearchProduct[],
  categoriesSettings: BarCategorySettings[],
): {
  bar: BarCategory[];
  take_away: BarCategory[];
} {
  // (1)
  const {take_away, bar} = splitProducts(products);

  // (2)
  const barCategories = splitProductsByCategory(bar);
  const takeAwayCategories = splitProductsByCategory(take_away);

  // (3)
  const filterdBarCategories = filterCategories(
    barCategories,
    categoriesSettings,
    'bar',
  );
  const filterdTakAwayCategories = filterCategories(
    takeAwayCategories,
    categoriesSettings,
    'take_away',
  );

  // (4)
  const sortedBarCategories = sortCategoriesByRank(
    filterdBarCategories,
    categoriesSettings,
  );
  const sortedTakeAwayCategories = sortCategoriesByRank(
    filterdTakAwayCategories,
    categoriesSettings,
  );

  return {
    bar: sortedBarCategories,
    take_away: sortedTakeAwayCategories,
  };
}
